import React from 'react';
// import { Meteor } from "meteor/meteor";
import PropTypes from 'prop-types';
import * as pbi from 'powerbi-client';
// APOLLO
import generatePowerBiEmbedToken from 'ApolloClient/Mutations/generatePowerBiEmbedToken';
import { graphql } from 'react-apollo';
// import Fullscreen from "react-full-screen";
// import DashboardLoading from 'components/common/DashboardLoading';
// import ErrorState from 'components/common/ErrorState';

// const { groupId } = Meteor.settings.public.powerbi;
let groupId = process.env.REACT_APP_POWERBI_GROUP_ID; // e.g. '23f2813e-47ef-465c-9bcc-f6c08eabb569';

// STYLES
// ===================================
const styles = {
  rowContainer: {
    width: 850,
    maxWidth: '90%',
    margin: 'auto',
    marginTop: 15,
  },
  button: {
    width: 150,
    height: 30,
    borderRadius: 30,
  },
  dashboardContainer: {
    margin: 'auto',
    maxWidth: '100%',
  },
};

// EXPORTED COMPONENT
// ===================================
class DashboardFrame extends React.Component {
  state = {
    isFull: false,
    loading: true,
    error: null,
  };

  componentDidMount() {
    const { reportId } = this.props;
    this.generateReport(reportId);
  }

  componentWillReceiveProps(nextProps) {
    if ('reportId' in nextProps && nextProps.reportId !== this.props.reportId) {
      this.generateReport(nextProps.reportId);
    }
    return true;
  }

  generateReport = async txtEmbedReportId => {
    console.log('==================> generateReport');
    let res;
    // Read embed application token from textbox
    this.setState({ loading: true });

    // if this dashboard has a groupId, use it, otherwise use the default that comes from an environment variable
    if (this.props.groupId) {
      groupId = this.props.groupId;
    }

    let variables = {
      txtEmbedReportId,
      groupId,
    };

    try {
      res = await this.props.generatePowerBiEmbedToken({ variables });
    } catch (err) {
      return console.log(err);
    }

    console.log(res);

    const txtAccessToken = res.data.generatePowerBiEmbedToken.token;
    // Read embed URL from textbox
    const txtEmbedUrl = `https://app.powerbi.com/reportEmbed?reportId=${txtEmbedReportId}&groupId=${groupId}`; //
    // Read report Id from textbox

    let powerbi = pbi; //window['powerbi-client']
    // Get models. models contains enums that can be used.
    const models = powerbi.models;

    // Embed configuration used to describe the what and how to embed.
    // This object is used when calling powerbi.embed.
    // This also includes settings and options such as filters.
    // You can find more information at https://github.com/Microsoft/PowerBI-JavaScript/wiki/Embed-Configuration-Details.

    // setup the filter options

    let basicFilter = {
      $schema: 'http://powerbi.com/product/schema#basic',
      filterType: 1,
      target: {
        table: 'UserSubscription',
        column: 'UserId',
      },
      operator: 'In',
      values: [this.props.userId],
    };

    if (this.props.filterType && this.props.filterType === 'byUser') {
      basicFilter.values = [this.props.currentUser.emails[0].address];
    }

    const config = {
      type: 'report',
      tokenType: models.TokenType.Embed,
      accessToken: txtAccessToken,
      embedUrl: txtEmbedUrl,
      id: txtEmbedReportId,
      filters: [basicFilter],
      permissions: models.Permissions.Read,
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: true,
      },
    };

    // Get a reference to the embedded report HTML element
    const embedContainer = document.getElementById('embedContainer');

    // Embed the report and display it within the div container.
    const report = window.powerbi.embed(embedContainer, config);

    // Report.off removes a given event handler if it exists.
    report.off('loaded');

    this.setState({ loading: false });

    // ON ERROR
    report.on('error', event => {
      console.log('report error', event.detail);
      report.off('error');
    });

    // ON SAVED
    report.off('saved');
    report.on('saved', event => {
      // console.log(event.detail);
      if (event.detail.saveAs) {
        console.log('In order to interact with the new report, create a new token and load the new report');
      }
    });

    // add the filters only after the report has loaded
    // report.on('loaded', () => {
    //   console.log('=====> Loaded');
    //   report.getFilters().then(filters => {
    //     filters.push(basicFilter);
    //     console.log({
    //       filters,
    //     });
    //     return report.setFilters(filters);
    //   });
    // });
  };

  render() {
    if (this.state.error) {
      return <div message={this.state.error} />;
    }

    return (
      <div
        style={{
          ...styles.dashboardContainer,
          ...{ position: 'relative', height: this.props.isFull ? '100%' : '85vh', minWidth: '100%' },
        }}
      >
        {this.state.loading && <div />}
        <div
          id="embedContainer"
          style={{ minHeight: '100%', minWidth: '100%', display: 'flex' }}
          className={this.state.loading ? 'display-none' : ''}
        />
      </div>
    );
  }
}

// maybe use this for full screen: https://github.com/snakesilk/react-fullscreen

DashboardFrame.propTypes = {
  userId: PropTypes.string.isRequired,
  reportId: PropTypes.string.isRequired,
};

export default graphql(generatePowerBiEmbedToken, { name: 'generatePowerBiEmbedToken' })(DashboardFrame);



// WEBPACK FOOTER //
// ./src/routes/app-dashboard-detail/DashboardFrame/index.js